import React from "react";

import clsx from "clsx";

import { type ReactSelectOption } from "@utils/index";

export interface BootstrapDropdownButtonProps {
  buttonText: React.ReactNode;
  buttonClassName: string;
  disabled?: boolean;
  choices: ReactSelectOption<string>[];
  onSelected: (value: string) => void;
}

export function BootstrapDropdownButton({
  buttonText,
  buttonClassName,
  disabled,
  choices,
  onSelected,
}: BootstrapDropdownButtonProps) {
  const [open, setOpen] = React.useState(false);

  const dropdownRef = React.useRef<HTMLDivElement>(null);

  const handleClick = React.useCallback(
    (event: MouseEvent) => {
      if (!dropdownRef.current) {
        return;
      }
      if (dropdownRef.current.contains(event.target as Node)) {
        return;
      }
      setOpen(false);
    },
    [setOpen, dropdownRef],
  );

  React.useEffect(() => {
    if (open) {
      document.addEventListener("mousedown", handleClick);
      return () => document.removeEventListener("mousedown", handleClick);
    }
  }, [handleClick, open]);

  return (
    <div className={clsx("dropdown", open && "show")}>
      <button
        className={clsx(buttonClassName, "button-toggle")}
        disabled={disabled}
        type="button"
        onClick={() => {
          if (!open) {
            setOpen(true);
          }
        }}
      >
        {buttonText}
      </button>
      <div className={clsx("dropdown-menu", open && "show")} ref={dropdownRef}>
        {choices.map(({ label, value }) => (
          <button
            key={value}
            className="dropdown-item"
            disabled={disabled}
            onClick={() => {
              onSelected(value);
              setOpen(false);
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
